import React from "react";
import type { ReactNode } from "react";
import cx from "classnames";

import { Heading } from "common/ui/Heading";
import { Paragraph } from "common/ui/Paragraph";

import { useWindowResize } from "common/middleware/hooks";

import styles from "./BasicRow.module.scss";

interface Props {
  row: { id?: string | number, onClick?: () => void, items: ReactNode[] },
}

export function BasicRow({ row }: Props) {
  const [windowWidth] = useWindowResize();

  const isWidthLessThan768 = windowWidth < 768;

  return (
    <tr
      className={cx(styles.BasicRow, {
        [styles.Linked]: row?.onClick,
      })}
      onClick={row?.onClick}
      data-testid="basic-row"
    >
      {row?.items.map((item, i) => {
        if (!item) {
          return;
        }

        if (typeof item === "string") {
          if (i === 0 && isWidthLessThan768) {
            return (
              <td key={i}>
                <Heading variant="h3">{item}</Heading>
              </td>
            )
          }

          return (
            <td key={i}>
              <Paragraph variant="p1">{item}</Paragraph>
            </td>
          )
        }

        return <td key={i}>{item}</td>
      })}
    </tr>
  )
}

